import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-dotted-dropdown',
  templateUrl: './dotted-dropdown.component.html',
  styleUrls: ['./dotted-dropdown.component.scss']
})
export class DottedDropdownComponent implements OnInit {

  constructor() { }

  @Input()
  actions: DottedDropdownAction[] = [];
  @Input()
  context: any;

  ngOnInit(): void {
  }

}

export interface DottedDropdownAction {
  name: string;
  color: 'default' | 'danger' | 'sec';
  action: (context: any) => void;
}
